import { CommonService } from './services/common.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShamsiFullPipe } from './Pipes/shamsi-full.pipe';
import { ProductActiveTimeModePipe } from './Pipes/product-active-time-mode.pipe';
import { TicketTimeModePipe } from './Pipes/ticket-time-mode.pipe';
import { AgoTimePipe } from './Pipes/ago-time.pipe';
import { ShortTextPipe } from './Pipes/short-text.pipe';
import { HmTimePipe } from './Pipes/hm-time.pipe';
import { ShamsiPipe } from './Pipes/shamsi.pipe';
import { DialogBoxComponent } from './dialog/dialog-box/dialog-box.component'
import { MatButtonModule, MatDialogModule } from '@angular/material';
import { OsFullnamePipe } from './Pipes/os-fullname.pipe';
import { InfoBoxComponent } from './dialog/info-box/info-box.component';
import { ConvertorPipe } from './Pipes/convertor.pipe';
import { MobileShowFrindlyPipe } from './Pipes/mobile-show-frindly.pipe';
import { TimerFormatPipe } from './Pipes/timer-format.pipe';
import { ShamsiWithTimePipe } from './Pipes/shamsi-with-time.pipe';
import { MmddPipe } from './Pipes/mmdd.pipe';
import { CopyToClipDirective } from './directives/copy-to-clip.directive';
import { SheedRateComponent } from './components/sheed-rate/sheed-rate.component';
import { FormsModule } from '@angular/forms';
import { SheedFooterComponent } from './components/sheed-footer/sheed-footer.component';
import { PackageTypeValuePipe } from './Pipes/package-type-value.pipe';
import { DescriptionBoxComponent } from './components/description-box/description-box.component';
import { SheedTileComponent } from './components/sheed-tile/sheed-tile.component';
import { ConfirmPasswordValidator } from './validators/confirm-password.validator';
import { DecodeHtmlPipe } from './Pipes/decode-html.pipe';
import { LogSenderTextPipe } from './Pipes/log-sender-text.pipe';
import { HttplinkPipe } from './Pipes/httplink.pipe';
import { SendSmsComponent } from '../admin/Pages/users/send-sms/send-sms.component';
import { MaximizModalDirective } from './directives/maximiz-modal.directive';
import { FormControlButtonComponent } from './components/form-control-button/form-control-button.component';
import { SheedDeviceInfoComponent } from './components/sheed-device-info/sheed-device-info.component';
import { SheedProductComponent } from './components/sheed-product/sheed-product.component';
import { MaskCodePipePipe } from './Pipes/mask-code-pipe.pipe';
import { LinkifyPipe } from './Pipes/linkify.pipe';
import { NewlineToBrPipe } from './Pipes/newline-to-br.pipe';
@NgModule({
  declarations: [ShamsiFullPipe, ProductActiveTimeModePipe,
    TicketTimeModePipe, AgoTimePipe, ShortTextPipe, HmTimePipe,
    ShamsiPipe, DialogBoxComponent, OsFullnamePipe, InfoBoxComponent,
    ConvertorPipe, MobileShowFrindlyPipe, TimerFormatPipe, ShamsiWithTimePipe,
    MmddPipe, CopyToClipDirective, SheedRateComponent, SheedFooterComponent,
    PackageTypeValuePipe, DescriptionBoxComponent, SheedTileComponent, DecodeHtmlPipe, LogSenderTextPipe, 
    HttplinkPipe, MaximizModalDirective, FormControlButtonComponent, SheedDeviceInfoComponent,
     SheedProductComponent, MaskCodePipePipe, LinkifyPipe, NewlineToBrPipe],
  imports: [
    FormsModule, CommonModule, MatDialogModule, MatButtonModule
  ],
  exports: [ShamsiFullPipe, ProductActiveTimeModePipe, SheedFooterComponent, PackageTypeValuePipe,
    TicketTimeModePipe, AgoTimePipe, ShortTextPipe, SheedTileComponent,SheedProductComponent,
    HmTimePipe, ShamsiPipe, DialogBoxComponent, LogSenderTextPipe,MaskCodePipePipe, LinkifyPipe,NewlineToBrPipe,
    OsFullnamePipe, ConvertorPipe, MobileShowFrindlyPipe, HttplinkPipe,SheedDeviceInfoComponent,
    TimerFormatPipe, ShamsiWithTimePipe, MmddPipe, CopyToClipDirective, SheedRateComponent, DescriptionBoxComponent,FormControlButtonComponent]
})
export class SharedModule { }
